import React, { useState, useEffect, useCallback } from 'react';
import { Box } from '@mui/material';
import Loader from '../Loader';
import CustomModal from '../CustomModal';

const PdfModal = ({ title, blob, show, onHide }) => {
  const [pdfLoading, setPdfLoading] = useState(true);

  const setBlob = useCallback(() => {
    setPdfLoading(true);

    if (blob) {
      const url = window.URL.createObjectURL(blob);

      const pdfElement = document.getElementById('pdf-modal');
      pdfElement.innerHTML = `
        <object data="${url}" type="application/pdf" width="100%" height="100%">
          <p>PDF not supported. <a href="${url}" download>Download</a></p>
        </object>
      `;
      setPdfLoading(false);
    }
  }, [blob]);

  useEffect(() => {
    setBlob();
  }, [setBlob]);

  const handleClose = () => {
    setPdfLoading(false);
    onHide();
  };

  return (
    <CustomModal
      open={show}
      handleClose={handleClose}
      title={title}
      width={1000}
      height={800}
      keepMounted={true}>
      {pdfLoading && <Loader />}
      <Box
        id="pdf-modal"
        sx={{
          position: 'relative',
          boxSizing: 'border-box',
          width: '100%',
          height: '90%',
          display: pdfLoading ? 'none' : 'block',
        }}></Box>
    </CustomModal>
  );
};

export default PdfModal;
